export default "__VITE_ASSET__64ISZExJTzy5fs6mREot5g__"